import Link from '@/components/LangLink/LangLink';
import { EXPO_CONFIG } from '@/api/expoConfig';

import logoInsNavarroMemoria from '@/assets/img/logos/logo-ins-navarro-memoria@3x.svg';
import logoGobNavarra from '@/assets/img/logos/logo-gob-navarra@3x.svg';
import icoDescarga from '@/assets/img/icons/ico-descarrega-informe@3x.svg';
import { getImageUrl } from '@/utils/dedaloUtils';
import { useNavigationStore } from '@/store/useNavigationStore';
import { parseJsonArray } from '@/utils/jsonUtils';

function Footer() {
    const pages = useNavigationStore((s) => s.pages);
    const creditsPage = pages.find((p) => p.section_id === EXPO_CONFIG.specialPages.credits);
    const report = useNavigationStore((s) => s.report);
    const reportUrlArray = parseJsonArray(report?.pdf_resolved);
    const reportUrl = getImageUrl(reportUrlArray[0]);

    return (
        <footer className="py-7 is-relative">
            <div className="wrapper flow--m">
                <div className="flow--2xl">
                    <div>
                        {report && reportUrl && (
                            <div className="report link-dn full-link">
                                <p className="is-family-secondary is-uppercase has-text-weight-bold is-size-2">
                                    {report.title}
                                </p>
                                <div className="is-flex is-align-items-center gap-2">
                                    <a
                                        href={reportUrl}
                                        className="has-text-weight-light"
                                        target="_blank"
                                    >
                                        {report.abstract}
                                    </a>
                                    <img src={icoDescarga} alt="" />
                                </div>
                            </div>
                        )}
                        {creditsPage && (
                            <div className="mt-6">
                                <Link
                                    to={creditsPage.web_path}
                                    className="has-text-weight-semibold"
                                >
                                    {creditsPage.term}
                                </Link>
                            </div>
                        )}
                    </div>

                    <ul className="footer-logos list-reset">
                        <li>
                            <a
                                href="https://oroibidea.es/"
                                target="_blank"
                                rel="noopener noreferrer"
                            >
                                <img
                                    loading="lazy"
                                    src={logoInsNavarroMemoria}
                                    alt="Logo Instituto Navarro para la Memoria"
                                />
                            </a>
                        </li>
                        <li>
                            <a
                                href="https://www.navarra.es/es/inicio"
                                target="_blank"
                                rel="noopener noreferrer"
                            >
                                <img
                                    loading="lazy"
                                    src={logoGobNavarra}
                                    alt="Logo Gobierno de Navarra"
                                />
                            </a>
                        </li>
                    </ul>
                </div>
            </div>
        </footer>
    );
}

export default Footer;
